import type LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import type * as React from 'react';
import { Tag } from '@verclam/ui-kit';

type Props = {
	readonly status: LabeledValueView;
};

/** `DocumentStatus`'s three values, `draft` → `in_review` → `verified`: the neutral tint reads
 * as "not yet reviewed", amber as "in progress", green as "settled". */
const SEVERITY_BY_STATUS_VALUE: Readonly<Record<string, 'secondary' | 'warning' | 'success'>> = {
	draft: 'secondary',
	in_review: 'warning',
	verified: 'success',
};

/**
 * The one status tag for a document: employed by the verification screen's header and by the
 * dossier's `DocumentCard` alike, colocated under `Shared/` for its two consumers. `status.value`
 * drives the tint, `status.label` (server French) is the text shown — an unrecognized value falls
 * back to the neutral tint rather than throwing.
 */
const DocumentStatusTag: React.FC<Props> = ({ status }) => {
	return (
		<Tag value={status.label} severity={SEVERITY_BY_STATUS_VALUE[status.value] ?? 'secondary'} rounded />
	);
};

export default DocumentStatusTag;
